import { useLayoutEffect, useState } from "react";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import CompactScheduleSlot from "./CompactScheduleSlot";
import ExtendedScheduleSlot from "./ExtendedScheduleSlot";
import { CancelSessionRequest } from "../../modal/views/CancelSessionRequest";
import WeeklySessionInfo from "../../sessions/WeeklySessionInfo";

export default function ScheduledSlot(props: {
  slot: CalendarScheduleSlotModel;
  compact: boolean;
  onClick: (slot: CalendarScheduleSlotModel) => void;
  cancel?: boolean;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  if (props.compact) {
    return (
      <>
        <CompactScheduleSlot setOpen={() => setOpen(true)} {...props} />
        {!!props?.slot && !!props?.cancel && (
          <>
            <WeeklySessionInfo
              session={props?.slot}
              onClose={() => setOpen(false)}
              cancel={!!props?.cancel}
              open={open}
              setIsOpen={() => {
                setOpen(false);
                setIsOpen(true);
              }}
            />
            <CancelSessionRequest
              isOpen={isOpen}
              session={props?.slot}
              setIsOpen={() => setIsOpen(false)}
            />
          </>
        )}
      </>
    );
  }
  return <ExtendedScheduleSlot {...props} />;
}
